import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { Snackbar } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Box,
  Select,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  FormHelperText,
} from "@mui/material";

import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from "../../components/400/styles";
import Fade from "@mui/material/Fade";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { SettingsOverscanOutlined } from "@mui/icons-material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const axios = require("axios");

// const api = axios.create({
//     baseURL: "http://localhost:5000/api/"
// })

export default function RegisterBatch() {
  const [semError, setSemError] = useState(false);
  const [aYear, setAyear] = useState([]);
  const api = useAxiosPrivate();
  const [open, setOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const location = useLocation();
  const [amount, setAmount] = useState([]);
  const navigate = useNavigate();
  //   const batchState = location.state.batchState;

  const schema = yup.object().shape({
    semester_term: yup.string().required(),
    acad_year: yup.number().required(),
    department: yup.string().required(),
    batch_year: yup.string().required("Batch year required"),
    year: yup.number().positive().required("year is required"),
    // admission_type : yup.number("invalid input").positive("invalid inpt").integer("invalid input").required("number of groups is required"),
    // program_type : yup.string().min(1,"invalid input,title is a character").max(1,"invalid input,title is alphabet"),
    numOfStu: yup
      .number("invalid input")
      .positive("invalid number")
      .integer("invalid input")
      .required("number of students is required"),
    studPerSec: yup.number().integer().positive().min(1).required(),
    studPerLab: yup.number().integer().positive().min(1).required(),
    studPerTut: yup.number().integer().positive().min(1).required(),
    studPerAdv: yup.number().integer().positive().min(1).required(),
    sections: yup
      .array()
      .of(
        yup.object().shape({
          value: yup.string().trim().required("number of students required"),
          // value : yup.lazy(value => )
        })
      )
      .test(
        "params",
        "sum of each sections student must be equal to total number of students",
        (values = []) => {
          const result = values.reduce((acc, curr) => {
            return acc + (parseInt(curr.value) || 0);
          }, 0);
          console.log(result, a.numOfStu);
          if (a.sections.length > 0) return result === parseInt(a.numOfStu);
          else return true;
        }
      ),
    // groups : yup.array().of(
    //     yup.object().shape({
    //         groupType : yup.string().trim().required("group type required"),
    //         groupNum : yup.number().positive().required("number of groups required"),
    //         section : yup.string()
    //     })
    // ),
  });

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      admission_type: "regular",
      program_type: "Bsc",
      department: "",
    },
    resolver: yupResolver(schema),
  });

  const a = getValues();

  const {
    fields: sectionField,
    append: sectionAppend,
    insert,
    remove: sectionRemove,
  } = useFieldArray({
    name: "sections",
    control,
  });

  const setDefault = async () => {
    const result = await api.get("getBatchConstant");

    const value = result.data.filter(
      (c) =>
        c.key === "stud_per_lab" ||
        c.key === "stud_per_sec" ||
        c.key === "stud_per_adv" ||
        c.key === "stud_per_tut" ||
        c.key === "stud_per_lec"
    );
    
    setValue("studPerSec", value[0].value);
    // setValue("studPerLec", value[2].value);
    setValue("studPerLab", value[1].value);
    setValue("studPerTut", value[3].value);
    setValue("studPerAdv", value[4].value);
  };

  const getDepartment = async () => {
    const result = await api.get("/getOffice");
    setAmount(result.data);
  };

  const getSemester = async () => {
    const a = [];
    const sem = await api.get("/getSemester");
    sem.data.forEach((c) => {
      a.push(c.academic_year);
    });
    const ab = a.filter((item, index) => a.indexOf(item) === index);
    setAyear(ab);
  };

  useEffect(() => {
    console.log("runnnn");
    getDepartment();
    getSemester();
    setDefault();
  }, [""]);

  const onSub = async (data) => {
    let amt = [];
    let title = [];
    let section = [];
    let lecGroup = [];
    let labGroup = [];
    let tutGroup = [];
    let advGroup = [];
    let temp = data.numOfStu;
    let temp1 = data.numOfStu;
    let temp3 = data.numOfStu;
    let temp4 = data.numOfSec;

    //section
    const mod = data.numOfStu % data.studPerSec;

    const numOfSec = Math.ceil(data.numOfStu / data.studPerSec);
    for (let i = 0; i < numOfSec - 1; i++) {
      section[i] = data.studPerSec;
    }
    if (mod === 0) section[numOfSec - 1] = data.studPerSec;
    else section[numOfSec - 1] = mod;
    //section title
    for (let i = 0; i < numOfSec; i++) {
      title.push(String.fromCharCode(i + 65));
    }

    //post objects
    const studs = [];
    for (let i = 0; i < data.sections.length; i++) {
      studs.push(data.sections[i].value);
    }
    const dtBatch = {
      batch_year: data.batch_year,
      program_type: data.program_type,
      admission_type: data.admission_type,
      no_of_students: data.numOfStu,
      department: data.department,
      year: data.year,
      status : "active"
    };
    const dtSection = {
      no_of_students:
        data.sections.length > 0
          ? studs
          : data.sections.length === 0
          ? section
          : 0,
      title: title,
    };
    //number of groups to be created

    const lec = [];
    const lab = [];
    const tut = [];
    const adv = [];
    dtSection.no_of_students.forEach((c) => {
      lec.push(Math.ceil(c / data.studPerSec));
      lab.push(Math.ceil(c / data.studPerLab));
      tut.push(Math.ceil(c / data.studPerTut));
      adv.push(Math.ceil(c / data.studPerAdv));
    });
    console.log(data.acad_year, data.semester_term);

    const semester = await api.get(
      `/getBatchSemester/${data.acad_year}/${data.semester_term}`
    );
    // insert batch to database
    if (semester.data.length > 0) {
      console.log(semester.data[0].id);
      let addedBatch = await api.post(
        "/addBatch",
        { ...dtBatch, isGraduate: false, semester_id: semester.data[0].id },
        {
          headers: { "content-type": "application/json" },
        }
      );

      if (addedBatch.data[1] === false) {
        setOpen(true);
      }
      //     //insert section to db

      if (addedBatch.data[1] === true) {
        let addedSection = await api
          .post(
            "/addSection",
            {
              ...dtSection,
              batch_id: addedBatch.data[0].id,
              lab_group: lab,
              lec_groups: lec,
              tut_groups: tut,
              adv_groups: adv,
            },
            {
              headers: { "content-type": "application/json" },
            }
          )
          .catch((err) => {
            console.log("error happened registering sections", err);
          });
          console.log(addedSection.status)
        if (addedSection.status === 200) {
          setSuccessOpen(true);
        }
      }
    }
    if (semester.data.length === 0) {
      setSemError(true)
      
    //   return (
    //     <Snackbar open={true}>
    //       <Alert severity="error">semester term not found</Alert>
    //     </Snackbar>
    //   );
    }
  };

  return (
    <div>
      <form width="100px" onSubmit={handleSubmit(onSub)}>
        <Box sx={header}>
          <Typography
            variant="span"
            sx={{
              fontSize: "1.14rem",
              fontWeight: "600",
              lineHeight: "23.2px",
              color: "primary.main",
            }}
          >
            Batch and Section Registration
          </Typography>
        </Box>
        <Box sx={formGroupContainer}>
          <Box sx={leftCol}>
            <Box sx={row}>
              <FormControl>
                <FormLabel sx={labelStyled}>academic year</FormLabel>
                <Controller
                  control={control}
                  name="try"
                  render={({ field }) => (
                    <>
                      <Select
                        {...register("acad_year")}
                        error={errors.acad_year ? true : false}
                      >
                        {aYear.map((d) => {
                          return (
                            <MenuItem key={d} value={d}>
                              {d}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </>
                  )}
                />
                <FormHelperText>
                  {errors.acad_year && "academic year is required"}
                </FormHelperText>
              </FormControl>

              <FormControl>
                <FormLabel sx={labelStyled}>semester term</FormLabel>
                <Controller
                  control={control}
                  name="semester_term"
                  render={({ field }) => (
                    <>
                      <Select
                        {...field}
                        error={errors.semester_term ? true : false}
                      >
                        <MenuItem value="I">I</MenuItem>
                        <MenuItem value="II">II</MenuItem>
                        <MenuItem value="summer">summer</MenuItem>
                      </Select>
                    </>
                  )}
                />
                <FormHelperText>
                  {errors.semester_term && "semester term required"}
                </FormHelperText>
              </FormControl>
            </Box>
            <FormControl>
              <FormLabel sx={labelStyled}>department</FormLabel>
              <Controller
                control={control}
                name="try"
                render={({ field }) => (
                  <>
                    <Select
                      {...register("department")}
                      error={errors.department ? true : false}
                    >
                      {amount.map((d) => {
                        return (
                          <MenuItem key={d.id} value={d.id}>
                            {d.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </>
                )}
              />
              <FormHelperText>
                {errors.department && "department is required"}
              </FormHelperText>
            </FormControl>
            <Box sx={row}>
              <FormControl sx={groupStyled}>
                <FormLabel sx={labelStyled}>batch Year</FormLabel>
                <TextField
                  id="year"
                  name="batch_year"
                  {...register("batch_year")}
                  fullWidth
                  error={errors.batch_year ? true : false}
                />
                <FormHelperText>{errors.batch_year?.message}</FormHelperText>
              </FormControl>

              <FormControl sx={groupStyled}>
                <FormLabel sx={labelStyled}>Year</FormLabel>
                <TextField
                  id="year"
                  name="year"
                  {...register("year")}
                  fullWidth
                  error={errors.year ? true : false}
                />
                <FormHelperText>
                  {errors.year && "year is required"}
                </FormHelperText>
              </FormControl>
            </Box>
            <FormControl>
              <FormLabel sx={labelStyled}>Program Type</FormLabel>
              <Controller
                control={control}
                name="program_type"
                render={({ field }) => (
                  <>
                    <Select {...field}>
                      <MenuItem value="Bsc">Bsc</MenuItem>
                      <MenuItem value="Msc">Masters</MenuItem>
                      <MenuItem value="phd">Phd</MenuItem>
                    </Select>
                  </>
                )}
              />
            </FormControl>
            <FormControl>
              <FormLabel sx={labelStyled}> Admission Type</FormLabel>
              <Controller
                control={control}
                name="admission_type"
                render={({ field }) => (
                  <>
                    <Select {...field}>
                      <MenuItem value="regular">regular</MenuItem>
                      <MenuItem value="extension">extension</MenuItem>
                    </Select>
                  </>
                )}
              />
            </FormControl>

            <FormControl sx={groupStyled} fullWidth>
              <FormLabel sx={labelStyled} htmlFor="numOfStu">
                Number Of Students
              </FormLabel>
              <OutlinedInput
                type="number"
                name="numOfStu"
                {...register("numOfStu")}
                error={errors.numOfStu ? true : false}
                variant="outlined"
                endAdornment={
                  <InputAdornment position="end">
                    <NavLink
                      to="/"
                      onClick={async (e) => {
                        e.preventDefault();
                        sectionRemove();
                        let section = [];
                        const a = getValues();
                        if (a.studPerSec !== "") {
                          const mod = a.numOfStu % a.studPerSec;

                          const numOfSec = Math.ceil(a.numOfStu / a.studPerSec);
                          for (let i = 0; i < numOfSec - 1; i++) {
                            section[i] = a.studPerSec;
                          }
                          if (mod === 0) section[numOfSec - 1] = a.studPerSec;
                          else section[numOfSec - 1] = mod;
                          console.log(section);
                          for (let i = 0; i < section.length; i++) {
                            if (section[i] !== 0)
                              sectionAppend({ value: section[i] });
                          }
                          console.log(getValues());
                        } else {
                        }
                      }}
                    >
                      <EditIcon color="secondary" />
                    </NavLink>
                  </InputAdornment>
                }
              />
              <FormHelperText>
                {errors.numOfStu && "number of students required"}
              </FormHelperText>
            </FormControl>

            {sectionField.map((item, index) => {
              let sec = String.fromCharCode(index + 65);
              return (
                <FormControl key={item.id}>
                  <FormLabel>
                    Section {String.fromCharCode(index + 65)}
                  </FormLabel>
                  <Controller
                    name={`sections.${index}.value`}
                    control={control}
                    // defaultValue={item.value}
                    render={({ sectionField }) => (
                      <OutlinedInput
                        type="number"
                        name="sections"
                        // defaultValue={field.value}
                        error={errors.sections ? true : false}
                        {...register(`sections.${index}.value`)}
                      />
                    )}
                  />
                  <FormHelperText>{errors.sections?.message}</FormHelperText>
                </FormControl>
              );
            })}
          </Box>

          <Divider orientation="vertical" flexItem />

          <Box sx={col}>
            <FormControl sx={groupStyled}>
              <FormLabel sx={labelStyled}>
                Students Per Section(lecture group)
              </FormLabel>
              <TextField
                type="number"
                name="studPerSec"
                {...register("studPerSec")}
                error={errors.studPerSec ? true : false}
                variant="outlined"
              />
              <FormHelperText>
                {errors.studPerSec && "students per section required"}
              </FormHelperText>
            </FormControl>

            {/* <FormControl sx={groupStyled}>
              <FormLabel sx={labelStyled}>students per Lecture Group</FormLabel>
              <TextField
                type="number"
                name="studPerLec"
                {...register("studPerLec")}
                error={errors.studPerLec ? true : false}
                variant="outlined"
              />
              <FormHelperText>
                {errors.studPerLec && "students per lecture group required"}
              </FormHelperText>
            </FormControl> */}

            <FormControl>
              <FormLabel sx={labelStyled}>students per Lab Group</FormLabel>
              <TextField
                type="number"
                name="studPerLab"
                {...register("studPerLab")}
                error={errors.studPerLab ? true : false}
                variant="outlined"
              />
              <FormHelperText>
                {errors.studPerLab && "students per lab group required"}
              </FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel sx={labelStyled}>
                students per tutorial Group
              </FormLabel>
              <TextField
                type="number"
                name="studPerTut"
                {...register("studPerTut")}
                error={errors.studPerTut ? true : false}
                variant="outlined"
              />
              <FormHelperText>
                {errors.studPerTut && "students per tutorial group required"}
              </FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel sx={labelStyled}>
                students per Advisory(supervision) Group
              </FormLabel>
              <TextField
                type="number"
                name="studPerAdv"
                {...register("studPerAdv")}
                error={errors.studPerAdv ? true : false}
                variant="outlined"
              />
              <FormHelperText>
                {errors.studPerAdv && "students per advisory group required"}
              </FormHelperText>
            </FormControl>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "1.8rem",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "teritiary.lighter1",
              "&:hover": {
                backgroundColor: "teritiary.main",
              },
            }}
            onClick={() => {
              navigate("/batch_management");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "secondary.lighter1",
              "&:hover": {
                backgroundColor: "secondary.main",
              },
            }}
            type="submit"
            onClick={() => {}}
          >
            Register
          </Button>
        </Box>
      </form>

      <Fade
        in={open}
        timeout={{ enter: 1000, exit: 1000 }}
        addEndListener={() => {
          setTimeout(() => {
            setOpen(false);
          }, 4000);
        }}
      >
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          batch already created
        </Alert>
      </Fade>

      <Fade
        in={semError}
        timeout={{ enter: 1000, exit: 1000 }}
        addEndListener={() => {
          setTimeout(() => {
            setSemError(false);
          }, 4000);
        }}
      >
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          semester term not found
        </Alert>
      </Fade>

      <Fade
        in={successOpen}
        timeout={{ enter: 1000, exit: 1000 }}
        addEndListener={() => {
          setTimeout(() => {
            setSuccessOpen(false);
          }, 4000);
        }}
      >
        <Alert>
          <AlertTitle>Success</AlertTitle>
          batch successfully created
        </Alert>
      </Fade>
    </div>
  );
}
